var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "container"
  }, [_vm.title ? _c('h3', [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _c('card', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading.subscription,
      expression: "loading.subscription"
    }],
    attrs: {
      "title": "Subscription"
    }
  }, [_c('span', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("   "), _vm.payload.is_vip ? _c('span', {
    staticStyle: {
      "color": "#67C23A",
      "font-style": "italic",
      "font-weight": "700"
    }
  }, [_vm._v(" VIP ")]) : _vm._e(), _vm.payload.is_manually_created ? _c('span', {
    staticStyle: {
      "color": "#E6A23C",
      "font-style": "italic"
    }
  }, [_vm._v(" Created via admin panel ")]) : _vm._e(), _vm.payload.is_deleted ? _c('span', {
    staticStyle: {
      "color": "#F56C6C",
      "font-style": "italic",
      "font-weight": "500",
      "opacity": "0.5"
    }
  }, [_vm._v(" (deleted) ")]) : _vm._e()]), _c('el-form', {
    attrs: {
      "label-width": "250px",
      "label-position": "left",
      "size": "small"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Created at"
    }
  }, [_c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetime"
    },
    model: {
      value: _vm.payload.created_at,
      callback: function ($$v) {
        _vm.$set(_vm.payload, "created_at", $$v);
      },
      expression: "payload.created_at"
    }
  })], 1)]), _c('el-form-item', {
    attrs: {
      "label": "Cancelled requested date"
    }
  }, [_c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetime"
    },
    model: {
      value: _vm.payload.cancelled_requested_at_date,
      callback: function ($$v) {
        _vm.$set(_vm.payload, "cancelled_requested_at_date", $$v);
      },
      expression: "payload.cancelled_requested_at_date"
    }
  })], 1)]), _c('el-form-item', {
    attrs: {
      "label": "Subscription ID"
    }
  }, [_c('el-input', {
    model: {
      value: _vm.payload.subscription_id,
      callback: function ($$v) {
        _vm.$set(_vm.payload, "subscription_id", $$v);
      },
      expression: "payload.subscription_id"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "Plan ID"
    }
  }, [_c('el-input', {
    model: {
      value: _vm.payload.plan_id,
      callback: function ($$v) {
        _vm.$set(_vm.payload, "plan_id", $$v);
      },
      expression: "payload.plan_id"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "Product name"
    }
  }, [_c('el-input', {
    model: {
      value: _vm.payload.product_name,
      callback: function ($$v) {
        _vm.$set(_vm.payload, "product_name", $$v);
      },
      expression: "payload.product_name"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "Interval"
    }
  }, [_c('el-select', {
    model: {
      value: _vm.payload.interval,
      callback: function ($$v) {
        _vm.$set(_vm.payload, "interval", $$v);
      },
      expression: "payload.interval"
    }
  }, [_c('el-option', {
    attrs: {
      "value": "monthly",
      "label": "Monthly"
    }
  }), _c('el-option', {
    attrs: {
      "value": "annually",
      "label": "Annually"
    }
  })], 1)], 1), _c('el-form-item', {
    attrs: {
      "label": "Master"
    }
  }, [_c('el-switch', {
    model: {
      value: _vm.payload.is_master,
      callback: function ($$v) {
        _vm.$set(_vm.payload, "is_master", $$v);
      },
      expression: "payload.is_master"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "Paused"
    }
  }, [_c('el-switch', {
    model: {
      value: _vm.payload.is_paused,
      callback: function ($$v) {
        _vm.$set(_vm.payload, "is_paused", $$v);
      },
      expression: "payload.is_paused"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "Archived"
    }
  }, [_c('el-switch', {
    model: {
      value: _vm.payload.is_archived,
      callback: function ($$v) {
        _vm.$set(_vm.payload, "is_archived", $$v);
      },
      expression: "payload.is_archived"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "Test"
    }
  }, [_c('el-switch', {
    model: {
      value: _vm.payload.is_test,
      callback: function ($$v) {
        _vm.$set(_vm.payload, "is_test", $$v);
      },
      expression: "payload.is_test"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "Trial"
    }
  }, [_c('el-switch', {
    model: {
      value: _vm.payload.is_trial,
      callback: function ($$v) {
        _vm.$set(_vm.payload, "is_trial", $$v);
      },
      expression: "payload.is_trial"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "Should cancel at period end"
    }
  }, [_c('el-switch', {
    model: {
      value: _vm.payload.should_cancel_at_period_end,
      callback: function ($$v) {
        _vm.$set(_vm.payload, "should_cancel_at_period_end", $$v);
      },
      expression: "payload.should_cancel_at_period_end"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "Trial end"
    }
  }, [_c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetime"
    },
    model: {
      value: _vm.payload.trial_end,
      callback: function ($$v) {
        _vm.$set(_vm.payload, "trial_end", $$v);
      },
      expression: "payload.trial_end"
    }
  })], 1)]), _c('el-form-item', {
    attrs: {
      "label": "Is paused and unpaid"
    }
  }, [_c('el-switch', {
    model: {
      value: _vm.payload.is_paused_and_unpaid,
      callback: function ($$v) {
        _vm.$set(_vm.payload, "is_paused_and_unpaid", $$v);
      },
      expression: "payload.is_paused_and_unpaid"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "Quantity"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 1,
      "step": 1,
      "step-strictly": ""
    },
    model: {
      value: _vm.payload.quantity,
      callback: function ($$v) {
        _vm.$set(_vm.payload, "quantity", $$v);
      },
      expression: "payload.quantity"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "Price per unit"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 1,
      "step": 1,
      "precision": 2
    },
    model: {
      value: _vm.payload.price_per_unit,
      callback: function ($$v) {
        _vm.$set(_vm.payload, "price_per_unit", $$v);
      },
      expression: "payload.price_per_unit"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "Status"
    }
  }, [_c('el-select', {
    model: {
      value: _vm.payload.status,
      callback: function ($$v) {
        _vm.$set(_vm.payload, "status", $$v);
      },
      expression: "payload.status"
    }
  }, [_c('el-option', {
    attrs: {
      "value": "active",
      "label": "active"
    }
  }), _c('el-option', {
    attrs: {
      "value": "canceled",
      "label": "canceled"
    }
  })], 1)], 1), _c('el-form-item', {
    attrs: {
      "label": "Updated at"
    }
  }, [_c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetime"
    },
    model: {
      value: _vm.payload.updated_at,
      callback: function ($$v) {
        _vm.$set(_vm.payload, "updated_at", $$v);
      },
      expression: "payload.updated_at"
    }
  })], 1)]), _c('el-form-item', {
    attrs: {
      "label": "Actions"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save")]), _c('el-button', {
    on: {
      "click": _vm.goToTeam
    }
  }, [_vm._v("View team")]), _c('div', {
    staticClass: "confirm-buttons"
  }, [_vm.payload.status === 'canceled' ? _c('Confirm', {
    on: {
      "confirm": _vm.restore
    }
  }, [_c('el-button', {
    attrs: {
      "type": "success"
    }
  }, [_vm._v("Restore")])], 1) : _c('Confirm', {
    on: {
      "confirm": _vm.downgrade
    }
  }, [_c('el-button', {
    attrs: {
      "type": "danger"
    }
  }, [_vm._v("Downgrade")])], 1)], 1), _c('Confirm', {
    on: {
      "confirm": _vm.onDeleteSubscription
    }
  }, [_c('el-button', {
    attrs: {
      "type": "danger"
    }
  }, [_vm._v("Delete")])], 1)], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }